<div data-test-id="filterable-hotel-list">
	@for (blok of carouselInputs(); track $index) {
		@if (carouselComponents) {
			<ndc-dynamic
				[ndcDynamicComponent]="carouselComponents[blok['component']]"
				[ndcDynamicInputs]="blok"
			/>
		}
	}
	<section class="bg-white section-spacing">
		<div class="section-inner section-gap flex-col">
			<div class="column-gap flex-col lg:flex-row">
				<div
					class="hidden flex-col lg:flex lg:w-1/4 lg:max-w-1/4 lg:min-w-1/4 lg:flex-none lg:basis-1/4"
					data-test-id="desktop"
				>
					<ng-container [ngTemplateOutlet]="filtersTpl" />
				</div>
				<div
					class="flex flex-col lg:min-w-0 lg:flex-1"
					data-test-id="content"
				>
					@for (blok of title(); track blok._uid) {
						<div class="flex">
							@if (titleComponents) {
								<ndc-dynamic
									[ndcDynamicComponent]="
										titleComponents[blok['component']]
									"
									[ndcDynamicInputs]="$any(blok)"
									class="hidden"
								/>
							}
						</div>
					}
					@for (blok of contentInputs(); track blok['_uid']) {
						<div class="flex">
							@if (richTextComponents) {
								<ndc-dynamic
									[ndcDynamicComponent]="
										richTextComponents[blok['component']]
									"
									[ndcDynamicInputs]="blok"
								/>
							}
						</div>
					}
					<vp-filter-heading
						[indicator]="activeFilterCount()"
						[numberOfResults]="numberOfResults()"
						[sortOptions]="sortOptions()"
						[title]="
							(numberOfResults() === 0 || numberOfResults() > 1
								? `storyblok.pages.filterable-list.${type()}-title-plural`
								: `storyblok.pages.filterable-list.${type()}-title-singular`
							) | translate: { amount: numberOfResults() }
						"
						(showMap)="mapFragment.openMap()"
						(sortChanged)="sortOption.set($event)"
					>
						<div data-test-id="mobile">
							<ng-container
								[ngTemplateOutlet]="filtersTpl"
								[ngTemplateOutletContext]="{
									showMapButton: false,
								}"
							/>
						</div>
					</vp-filter-heading>
					@if (activeScenario() === 'vdc-hotels') {
						<sb-filterable-list-vdc-hotels
							[baseUrl]="baseUrl()"
							[business]="valkBusiness()"
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					} @else if (activeScenario() === 'vdc-packages') {
						<sb-filterable-list-vdc-packages
							[baseUrl]="baseUrl()"
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					} @else if (activeScenario() === 'vdcvhi-hotels') {
						<sb-filterable-list-vdcvhi-hotels
							[baseUrl]="baseUrl()"
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					} @else if (activeScenario() === 'vdc-rooms') {
						<sb-filterable-list-vdc-rooms
							[showPrices]="showPrices()"
							[sortOption]="sortOption()"
						/>
					}
				</div>
			</div>
		</div>
	</section>
	<vp-panel
		[label]="'global.map' | translate"
		[open]="mapFragment.mapOpen()"
		(closed)="mapFragment.closeMap()"
		data-test-id="filterable-list-map"
	>
		<div class="flex h-full">
			<aside
				class="hidden w-1/4 shrink-0 flex-col overflow-y-auto border-r border-ui-100 p-6 lg:flex"
				data-test-id="filterable-list-map-filters"
			>
				<ng-container
					[ngTemplateOutlet]="filtersTpl"
					[ngTemplateOutletContext]="{ showMapButton: false }"
				/>
			</aside>
			<div
				class="relative flex-1"
				data-test-id="filterable-list-map-canvas"
			>
				@if (mapFragment.mapOpen()) {
					@defer (on immediate) {
						<vp-map
							[cardTemplate]="poiCardTpl"
							[pinpoints]="mapPinpoints()"
							[view]="mapView()"
							class="block size-full"
							className="size-full"
						/>

						<ng-template #poiCardTpl let-index="index">
							@let hotel = mapHotels()[index];

							<div
								class="w-96 max-w-96"
								data-test-id="filterable-list-map-card"
							>
								<vp-image-card
									[image]="hotel.image"
									[isClickable]="!!hotel.cardUrl"
									(emitClick)="openHotel(hotel.cardUrl)"
								>
									@if (hotel.rating?.score) {
										<vp-social-proof
											[rating]="hotel.rating.score"
											size="sm"
										/>
									}
									<div class="mt-auto">
										<span
											class="heading-group-overline text-white"
										>
											{{ hotel.country }}
										</span>
										<span
											class="mb-0 font-display text-2xl font-normal text-shadow md:text-3xl"
										>
											{{ hotel.name }}
										</span>
									</div>
								</vp-image-card>
							</div>
						</ng-template>
					}
				}
				<div class="absolute top-6 left-6 z-10 lg:hidden">
					<vp-filter-sheet-button
						[indicator]="activeFilterCount()"
						[label]="'compositions.filters.title' | translate"
						[numberOfResults]="numberOfResults()"
						[open]="mapFragment.filtersOpen()"
						[openable]="true"
						(closed)="mapFragment.closeFilters()"
						(opened)="mapFragment.openFilters()"
						data-test-id="filterable-list-map-filters-button"
						iconLeading="assets/icons/icon-filter.svg"
					>
						<ng-container
							[ngTemplateOutlet]="filtersTpl"
							[ngTemplateOutletContext]="{ showMapButton: false }"
						/>
					</vp-filter-sheet-button>
				</div>
			</div>
		</div>
	</vp-panel>
	@for (blok of subContentInput(); track $index) {
		@if (subContentComponents) {
			<ndc-dynamic
				[ndcDynamicComponent]="subContentComponents[blok['component']]"
				[ndcDynamicInputs]="blok"
			/>
		}
	}
</div>

<ng-template #filtersTpl let-showMapButton="showMapButton">
	<vp-filters
		[activeFilters]="filterableListService.filters()"
		[filters]="filters()"
		[searchLoading]="locationSearch.loading()"
		[searchLocation]="locationSearch.selectedLabel()"
		[searchOptions]="locationSearch.options()"
		[showMapButton]="showMapButton !== false"
		(activeFiltersChange)="filterableListService.filters.set($event)"
		(searchCleared)="locationSearch.onCleared()"
		(searchSelected)="locationSearch.onSelected($event)"
		(searched)="locationSearch.onSearched($event)"
		(showMap)="mapFragment.openMap()"
	/>
</ng-template>
